/** Extract a user-facing message from a FastAPI / fetch error body. */
export function parseApiErrorMessage(
  body: string,
  status: number
): string {
  const fallback = body.trim() || `HTTP ${status}`;

  try {
    const json = JSON.parse(body) as { detail?: unknown };
    const { detail } = json;

    if (typeof detail === "string" && detail.trim()) {
      return detail.trim();
    }

    if (Array.isArray(detail)) {
      const messages = detail
        .map((entry) => {
          if (typeof entry === "string") return entry;
          if (entry && typeof entry === "object") {
            if ("msg" in entry) {
              const msg = (entry as { msg?: unknown }).msg;
              return typeof msg === "string" ? msg : "";
            }
            if ("message" in entry) {
              const message = (entry as { message?: unknown }).message;
              return typeof message === "string" ? message : "";
            }
          }
          return "";
        })
        .filter(Boolean);

      if (messages.length > 0) {
        return messages.join(", ");
      }
    }
  } catch {
    // Plain text or non-JSON body — use as-is when safe.
  }

  return fallback;
}
